module.exports = __webpack_public_path__ + "img/visitorCartV3.9a422406.svg";